// Yasmin — the Fable+ AI assistant (£3.70/month add-on). Same endpoints as the app's Relay › Yasmin tab.
import { api } from "@/lib/api";

export const yasminApi = {
  access: () => api("/yasmin/access"),
  checkout: (return_base) => api("/yasmin/checkout", { method: "POST", body: { return_base } }),
  checkoutStatus: (session_id) => api(`/yasmin/checkout/status/${encodeURIComponent(session_id)}`),
  cancel: () => api("/yasmin/cancel", { method: "POST", body: {} }),
  resume: () => api("/yasmin/resume", { method: "POST", body: {} }),
  chat: (message, session_id, location, plan_id) =>
    api("/yasmin/chat", { method: "POST", body: { message, session_id: session_id || undefined, location: location || undefined, plan_id: plan_id || undefined } }),
  plans: () => api("/yasmin/plans"),
  plan: (pid) => api(`/yasmin/plans/${pid}`),
  save: (pid, title) => api(`/yasmin/plans/${pid}/save`, { method: "POST", body: { title } }),
  watches: () => api("/yasmin/flight-watches"),
  unwatch: (id) => api("/yasmin/flight-watches/" + id, { method: "DELETE" }),
  pick: (pid, body) => api(`/yasmin/plans/${pid}/pick`, { method: "POST", body }),
};

export const YASMIN_EXAMPLES = [
  "Madrid 10–20 Dec, morning flight out, night flight back, hotel within 5 km of the stadium.",
  "Haircut with my regular barber on Friday between 12 and 2.",
  "Plan my Saturday in Manchester: brunch, something outdoors, a gig in the evening.",
  "Find me a massage near Shoreditch tomorrow after 6.",
];
